export const uppercaseRegex = /[A-Z]/;

export const lowercaseRegex = /[a-z]/;

export const numberRegex = /[0-9]/;

export const specialCharacterRegex = /[\W_]/;
